/* eslint-disable indent */

import AjaxFormExt from './forms/AjaxFormExt';
import FormDependencyCheckboxesMixin from './forms/FormDependencyCheckboxesMixin';
import WidgetsMgr from 'widgets/widgetsMgr';
import InputDependencyCheckbox from './forms/InputDependencyCheckbox';
import drawerDialog from './global/drawerDialog';
import drawerDialogToggle from './global/drawerDialogToggle';
import BasicInputExt from './forms/BasicInputExt';
import InputSelectExt from './forms/InputSelectExt';
import CoreGeolocation from './global/CoreGeolocation';
import InputEmail from './forms/InputEmail';
import InputPasswordExt from './forms/InputPasswordExt';
import HeroCarousel from 'widgets/global/HeroCarousel';
import ViewMore from 'widgets/global/ViewMore';
import CoreHeader from './global/CoreHeader';
import CoreFocusHighlighter from './global/CoreFocusHighlighter';
import CoreStickyHeader from './header/CoreStickyHeader';
import CoreProductTile from './product/CoreProductTile';
import InputTextMixin from './forms/InputTextMixin';
import CoreCarousel from './global/CoreCarousel';
import ShowMore from './global/ShowMore';
import CoreModal from './global/CoreModal';
import CoreGlobalAlerts from './global/CoreGlobalAlerts';
import CoreSearchBox from './search/CoreSearchBox';
import AddToCartButton from './product/AddToCartButton';
import InputDateNumeric from './forms/InputDateNumeric';
import EmailSubscribeGeneral from './forms/ajax/EmailSubscribeGeneral';
import LoginForm from 'widgets/forms/ajax/LoginForm';
import CoreInputRadio from './forms/CoreInputRadio';
import ConsentManagement from './global/ConsentManagement';
import UsercentricsCM from './global/UsercentricsCM';
import OneTrustCM from './global/OneTrustCM';
import SmsSubscriptionMixin from './global/SmsSubscriptionMixin';
import AccessibilityFocusTrapMixin from 'widgets/global/AccessibilityFocusTrapMixin';
import ProductFocusManagementMixin from './global/ProductFocusManagementMixin';
import OptimizelyMeta from './global/OptimizelyMeta';
import OptimizelyFeatureExpMeta from './global/OptimizelyFeatureExpMeta';
import OptimizelyWebExpMeta from './global/OptimizelyWebExpMeta';
import CoreBackToTop from './global/CoreBackToTop';
import DateNumericPicker from './account/DateNumericPicker';
import CoreConsentTracking from './global/CoreConsentTracking';
import BreadcrumbsTrack from './global/BreadcrumbsTrack';
import FooterNewsletter from './global/FooterNewsletter';
import FooterTrack from './global/FooterTrack';
import AreaCodeMixin from './global/AreaCodeMixin';
import CoreAlternativeImage from './product/CoreAlternativeImage';
import CoreAccordionItemMixin from './global/CoreAccordionItemMixin';
import CoreButton from './global/CoreButton';
import RecommendationsWrapper from './product/RecommendationsWrapper';
import ProductBreadcrumbs from './product/ProductBreadcrumbs';
import AccessibilityFocusMixin from 'widgets/global/AccessibilityFocusMixin';
import FitGuideMgr from './product/fitguide/FitGuideMgr';
import FitGuideForm from './product/fitguide/FitGuideForm';
import FitGuideResult from './product/fitguide/FitGuideResult';
import AddToCartMixin from 'widgets/product/AddToCartMixin';
import CoreAddToCartMixin from './product/CoreAddToCartMixin';
import UniversalLink from './global/UniversalLink';
import FriendlyCaptcha from './global/FriendlyCaptcha';
import AjaxFormWithFriendlyCaptcha from './forms/AjaxFormWithFriendlyCaptcha';
import AjaxFormWithAttachment from './forms/AjaxFormWithAttachment';
import OptimizelyEvents from './global/OptimizelyEvents';
import InputNumber from 'widgets/forms/InputNumber';
import CoreTabs from './global/CoreTabs';
import AjaxResponseMessageMixin from './forms/AjaxResponseMessageMixin';
import InputFile from './forms/InputFile';
import InputTel from 'widgets/forms/InputTel';
import MemberPriceBadge from './product/MemberPriceBadge';

WidgetsMgr.addWidgetsList('global.core', () => [
    ['button', CoreButton, 'button'],
    ['basicInput', BasicInputExt, 'basicInput'],
    ['inputFile', InputFile, 'basicInput'],
    ['drawerDialog', drawerDialog, 'modal'],
    ['drawerDialogToggle', drawerDialogToggle],
    ['geolocation', CoreGeolocation, 'geolocation'],
    ['inputPassword', InputPasswordExt, 'inputPassword'],
    ['inputEmail', InputEmail, 'inputText'],
    ['heroCarousel', HeroCarousel],
    ['ajaxform', AjaxFormExt, 'ajaxform'],
    ['ajaxform', FormDependencyCheckboxesMixin, 'ajaxform'],
    ['ajaxform', AreaCodeMixin, 'ajaxform'],
    ['inputSelect', InputSelectExt, 'inputSelect'],
    ['inputDependencyCheckbox', InputDependencyCheckbox, 'inputCheckbox'],
    ['viewMore', ViewMore],
    ['header', CoreHeader, 'header'],
    ['focusHighlighter', CoreFocusHighlighter, 'focusHighlighter'],
    ['stickyHeader', CoreStickyHeader, 'stickyHeader'],
    ['productTile', CoreProductTile, 'productTile'],
    ['inputText', InputTextMixin, 'inputText'],
    ['showMore', ShowMore],
    ['showMore', AccessibilityFocusTrapMixin, 'showMore'],
    ['modal', CoreModal, 'modal'],
    ['carousel', CoreCarousel, 'carousel'],
    ['globalAlerts', CoreGlobalAlerts, 'globalAlerts'],
    ['searchBox', AccessibilityFocusMixin, 'searchBox'],
    ['searchBox', CoreSearchBox, 'searchBox'],
    ['addToCartButton', AddToCartButton, 'processButton'],
    ['inputDateNumeric', InputTextMixin, 'inputText'],
    ['inputDateNumeric', InputDateNumeric, 'inputDateNumeric'],
    ['emailSubscribe', AccessibilityFocusMixin, 'emailSubscribe'],
    ['emailSubscribe', SmsSubscriptionMixin, 'emailSubscribe'],
    ['emailSubscribe', EmailSubscribeGeneral, 'emailSubscribe'],
    ['loginForm', LoginForm, 'ajaxform'],
    ['inputRadio', CoreInputRadio, 'inputRadio'],
    ['optimizelyMeta', OptimizelyMeta],
    ['optimizelyFeatureExpMeta', OptimizelyFeatureExpMeta, 'optimizelyMeta'],
    ['optimizelyWebExpMeta', OptimizelyWebExpMeta, 'optimizelyMeta'],
    ['backtotop', CoreBackToTop, 'backtotop'],
    ['consentManagement', ConsentManagement],
    ['usercentricsCM', UsercentricsCM, 'consentManagement'],
    ['onetrustCM', OneTrustCM, 'consentManagement'],
    ['dateNumericPicker', DateNumericPicker],
    ['consentTracking', CoreConsentTracking, 'consentTracking'],
    ['breadcrumbsTrack', BreadcrumbsTrack],
    ['footerNewsletter', FooterNewsletter],
    ['footerTrack', FooterTrack],
    ['accordionItem', CoreAccordionItemMixin, 'accordionItem'],
    ['productTile', CoreAlternativeImage, 'productTile'],
    ['recommendationsWrapper', RecommendationsWrapper],
    ['productBreadcrumbs', ProductBreadcrumbs],
    ['fitGuideMgr', FitGuideMgr],
    ['fitGuideForm', FitGuideForm],
    ['fitGuideResult', FitGuideResult],
    ['fitGuideResult', AddToCartMixin, 'fitGuideResult'],
    ['fitGuideResult', CoreAddToCartMixin, 'fitGuideResult'],
    ['universalLink', UniversalLink],
    ['friendlyCaptcha', FriendlyCaptcha],
    ['ajaxform', AjaxFormWithFriendlyCaptcha, 'ajaxform'],
    ['ajaxform', AjaxFormWithAttachment, 'ajaxform'],
    ['optimizelyEvents', OptimizelyEvents],
    ['inputNumber', InputNumber, 'basicInput'],
    ['tabs', CoreTabs, 'tabs'],
    ['ajaxform', AjaxResponseMessageMixin, 'ajaxform'],
    ['inputTel', InputTel, 'inputText'],
    ['memberPriceBadge', MemberPriceBadge]
]);

const hasContext = (context: string) => window.contexts.includes(context);

WidgetsMgr.asyncLists.push({
    getLoadingFlag: () => hasContext('header'),
    load: () =>
        Promise.all([
            import(/* webpackChunkName: 'header.widgets' */ './header/CoreMenuBarItem').then(d => d.default),
            import(/* webpackChunkName: 'header.widgets' */ './cart/CoreMinicart').then(d => d.default),
            import(/* webpackChunkName: 'header.widgets' */ './cart/MinicartDialog').then(d => d.default),
            import(/* webpackChunkName: 'header.widgets' */ './header/HeaderDialog').then(d => d.default),
            import(/* webpackChunkName: 'header.widgets' */ './header/ScrollToNewsletterSubscription').then(d => d.default),
            import(/* webpackChunkName: 'account.widgets' */ 'widgets/forms/AjaxFormResponseContainerMigrated').then(d => d.default),
            import(/* webpackChunkName: 'header.widgets' */ './header/CoreHamburgerMenuItem').then(d => d.default),
            import(/* webpackChunkName: 'header.widgets' */ './header/CoreMenuPanel').then(d => d.default)
        ]).then(deps => {
            const [
                CoreMenuBarItem,
                CoreMinicart,
                MinicartDialog,
                HeaderDialog,
                ScrollToNewsletterSubscription,
                AjaxFormResponseContainerMigrated,
                CoreHamburgerMenuItem,
                CoreMenuPanel
            ] = deps;

            return {
                listId: 'header.widgets.core',
                widgetsDefinition: () => [
                    ['menuBarItem', CoreMenuBarItem, 'menuBarItem'],
                    ['minicart', CoreMinicart, 'minicart'],
                    ['minicartDialog', MinicartDialog, 'headerDialog'],
                    ['headerDialog', HeaderDialog, 'modal'],
                    ['scrollToNewsletter', ScrollToNewsletterSubscription],
                    ['ajaxFormResponseContainerMigrated', AjaxFormResponseContainerMigrated, 'modal'],
                    ['hamburgerMenuItem', CoreHamburgerMenuItem, 'hamburgerMenuItem'],
                    ['menuPanel', CoreMenuPanel, 'menuPanel']
                ]
            };
        })
});

if (window.sfccData?.countrySelectorType !== 'list') {
    WidgetsMgr.asyncLists.push({
        getLoadingFlag: () => hasContext('header'),
        load: () =>
            Promise.all([import(/* webpackChunkName: 'header.core' */ './forms/ajax/CoreCountrySelectorForm').then(d => d.default)]).then(deps => {
                const [CoreCountrySelectorForm] = deps;

                return {
                    listId: 'header.countrySelector.core',
                    widgetsDefinition: () => [['countrySelectorForm', CoreCountrySelectorForm, 'countrySelectorForm']]
                };
            })
    });
}

WidgetsMgr.asyncLists.push({
    getLoadingFlag: () => hasContext('return'),
    load: () =>
        Promise.all([
            import(/* webpackChunkName: 'return.widgets' */ './return/ReturnPickupCalendar').then(d => d.default),
            import(/* webpackChunkName: 'return.widgets' */ './forms/ajax/ReturnForm').then(d => d.default),
            import(/* webpackChunkName: 'product.widgets' */ 'widgets/forms/InputStepper').then(d => d.default),
            import(/* webpackChunkName: 'return.widgets' */ './forms/ReturnLookupForm').then(d => d.default)
        ]).then(deps => {
            const [ReturnPickupCalendar, ReturnForm, InputStepper, ReturnLookupForm] = deps;

            return {
                listId: 'return.widgets.core',
                widgetsDefinition: () => [
                    ['returnPickupCalendar', ReturnPickupCalendar],
                    ['returnForm', ReturnForm, 'ajaxform'],
                    ['inputStepper', InputStepper, 'basicInput'],
                    ['returnLookUpForm', ReturnLookupForm, 'ajaxform']
                ]
            };
        })
});

WidgetsMgr.asyncLists.push({
    getLoadingFlag: () => hasContext('pdp'),
    load: () =>
        Promise.all([
            import(/* webpackChunkName: 'product.widgets' */ './product/CoreProductDetail').then(d => d.default),
            import(/* webpackChunkName: 'product.widgets' */ './product/CoreProductAvailabilityMixin').then(d => d.default),
            import(/* webpackChunkName: 'product.widgets' */ './product/SignInToBuyMixin').then(d => d.default),
            import(/* webpackChunkName: 'product.widgets' */ './forms/ajax/SignInToBuyLoginForm').then(d => d.default),
            import(/* webpackChunkName: 'product.widgets' */ './forms/ajax/EnrollLoyaltyToBuyLoginForm').then(d => d.default),
            import(/* webpackChunkName: 'product.widgets' */ './account/RegistrationForm').then(d => d.default),
            import(/* webpackChunkName: 'product.widgets' */ './account/SignInToBuyRegistrationForm').then(d => d.default),
            import(/* webpackChunkName: 'product.widgets' */ './forms/ajax/CoreBackInStock').then(d => d.default),
            import(/* webpackChunkName: 'product.widgets' */ './global/CoreSizeTabs').then(d => d.default),
            import(/* webpackChunkName: 'product.widgets' */ './product/ProductDeliveryOptions').then(d => d.default),
            import(/* webpackChunkName: 'product.widgets' */ './product/ChangeStoreSelectorBtn').then(d => d.default),
            import(/* webpackChunkName: 'product.widgets' */ './product/ProductStoreSelector').then(d => d.default),
            import(/* webpackChunkName: 'product.widgets' */ 'widgets/product/AddToCartStickyMixin').then(d => d.default),
            import(/* webpackChunkName: 'product.widgets' */ './product/CoreAddToCartStickyMixin').then(d => d.default),
            import(/* webpackChunkName: 'product.widgets' */ './product/CoreProductVariantSelect').then(d => d.default),
            import(/* webpackChunkName: 'product.widgets' */ 'widgets/global/CarouselSwiper').then(d => d.default),
            import(/* webpackChunkName: 'product.widgets' */ './product/CoreProductVariationChangeMixin').then(d => d.default),
            import(/* webpackChunkName: 'product.widgets' */ './product/MobileProductVariantSelect').then(d => d.default),
            import(/* webpackChunkName: 'product.widgets' */ './product/CoreProductVideo').then(d => d.default),
            import(/* webpackChunkName: 'product.widgets' */ './product/CoreAddAllToCartMixin').then(d => d.default),
            import(/* webpackChunkName: 'product.widgets' */ './product/CoreRecentlyViewedMixin').then(d => d.default),
            import(/* webpackChunkName: 'product.widgets' */ './product/FootbedCarousel').then(d => d.default),
            import(/* webpackChunkName: 'product.widgets' */ './product/FitPredictor').then(d => d.default),
            import(/* webpackChunkName: 'product.widgets' */ './product/WannaARIFrame').then(d => d.default),
            import(/* webpackChunkName: 'product.widgets' */ './product/WannaARButton').then(d => d.default),
            import(/* webpackChunkName: 'product.widgets' */ './product/YotpoRecommendationSummary').then(d => d.default),
            import(/* webpackChunkName: 'product.widgets' */ './product/CoreProductStickyPanel').then(d => d.default),
            import(/* webpackChunkName: 'clp.widgets' */ 'core/global/VimeoVideo').then(d => d.default),
            import(/* webpackChunkName: 'product.widgets' */ 'core/global/VideoTeaser').then(d => d.default),
            import(/* webpackChunkName: 'product.widgets' */ 'core/global/NewsletterFlyIn').then(d => d.default),
            import(/* webpackChunkName: 'product.widgets' */ 'core/global/NewsletterAutoFlyIn').then(d => d.default),
            import(/* webpackChunkName: 'product.widgets' */ './product/AvailabilityReminderMixin').then(d => d.default),
            import(/* webpackChunkName: 'product.widgets' */ './product/AvailabilityReminderModalMixin').then(d => d.default),
            import(/* webpackChunkName: 'product.widgets' */ './product/SignInToBuyModalMixin').then(d => d.default),
            import(/* webpackChunkName: 'product.widgets' */ './product/EnrollLoyaltyToBuyModalMixin').then(d => d.default),
            import(/* webpackChunkName: 'product.widgets' */ 'core/product/ProductActionButton').then(d => d.default),
            import(/* webpackChunkName: 'product.widgets' */ 'core/product/StoreAvailabilityBtn').then(d => d.default),
            import(/* webpackChunkName: 'product.widgets' */ 'core/product/ReviewsAccordionItem').then(d => d.default),
            import(/* webpackChunkName: 'product.widgets' */ './product/PageLoadActionProcessor').then(d => d.default),
            import(/* webpackChunkName: 'product.widgets' */ './product/DynamicRecommendations').then(d => d.default),
            import(/* webpackChunkName: 'cart.widgets' */ './global/OptimizelyMixin').then(d => d.default),
            import(/* webpackChunkName: 'product.widgets' */ './product/ProductFeatures').then(d => d.default),
            import(/* webpackChunkName: 'product.widgets' */ './product/PersonalizationMixin').then(d => d.default),
            import(/* webpackChunkName: 'product.widgets' */ './product/PersonalizationSummary').then(d => d.default),
            import(/* webpackChunkName: 'product.widgets' */ './product/PersonalizationDrawer').then(d => d.default),
            import(/* webpackChunkName: 'product.widgets' */ './product/PersonalizationImagesCarousel').then(d => d.default),
            import(/* webpackChunkName: 'product.widgets' */ './product/TamaraWidget').then(d => d.default)
        ]).then(deps => {
            const [
                CoreProductDetail,
                CoreProductAvailabilityMixin,
                SignInToBuyMixin,
                SignInToBuyLoginForm,
                EnrollLoyaltyToBuyLoginForm,
                RegistrationForm,
                SignInToBuyRegistrationForm,
                CoreBackInStock,
                SizeTabs,
                ProductDeliveryOptions,
                ChangeStoreSelectorBtn,
                ProductStoreSelector,
                AddToCartStickyMixin,
                CoreAddToCartStickyMixin,
                CoreProductVariantSelect,
                CarouselSwiper,
                CoreProductVariationChangeMixin,
                MobileProductVariantSelect,
                CoreProductVideo,
                CoreAddAllToCartMixin,
                CoreRecentlyViewedMixin,
                FootbedCarousel,
                FitPredictor,
                WannaARIFrame,
                WannaARButton,
                YotpoRecommendationSummary,
                CoreProductStickyPanel,
                VimeoVideo,
                VideoTeaser,
                NewsletterFlyIn,
                NewsletterAutoFlyIn,
                AvailabilityReminderMixin,
                AvailabilityReminderModalMixin,
                SignInToBuyModalMixin,
                EnrollLoyaltyToBuyModalMixin,
                ProductActionButton,
                StoreAvailabilityBtn,
                ReviewsAccordionItem,
                PageLoadActionProcessor,
                DynamicRecommendations,
                OptimizelyMixin,
                ProductFeatures,
                PersonalizationMixin,
                PersonalizationSummary,
                PersonalizationDrawer,
                PersonalizationImagesCarousel,
                TamaraWidget
            ] = deps;

            return {
                listId: 'product.widgets.core',
                widgetsDefinition: () => [
                    ['productDetail', CoreAddToCartMixin, 'productDetail'],
                    ['productDetail', CoreProductDetail, 'productDetail'],
                    ['productDetail', CoreRecentlyViewedMixin, 'productDetail'],
                    ['productDetail', CoreProductAvailabilityMixin, 'productDetail'],
                    ['productDetail', SignInToBuyMixin, 'productDetail'],
                    ['productDetail', OptimizelyMixin, 'productDetail'],
                    ['signInToBuyLoginForm', SignInToBuyLoginForm, 'loginForm'],
                    ['enrollLoyaltyToBuyLoginForm', EnrollLoyaltyToBuyLoginForm, 'loginForm'],
                    ['ajaxform', SmsSubscriptionMixin, 'ajaxform'],
                    ['registrationForm', RegistrationForm, 'ajaxform'],
                    ['signInToBuyRegistrationForm', SignInToBuyRegistrationForm, 'registrationForm'],
                    ['backInStock', CoreBackInStock, 'backInStock'],
                    ['sizeTabs', SizeTabs, 'tabs'],
                    ['sizeTabs', OptimizelyMixin, 'sizeTabs'],
                    ['productDeliveryOptions', ProductDeliveryOptions],
                    ['changeStoreSelectorBtn', ChangeStoreSelectorBtn],
                    ['productStoreSelector', ProductStoreSelector],
                    ['productDetail', AddToCartStickyMixin, 'productDetail'],
                    ['productDetail', CoreAddToCartStickyMixin, 'productDetail'],
                    ['productDetail', CoreProductVariationChangeMixin, 'productDetail'],
                    ['productDetail', PersonalizationMixin, 'productDetail'],
                    ['personalizationSummary', PersonalizationSummary],
                    ['personalizationDrawer', PersonalizationDrawer, 'modal'],
                    ['productVariantSelect', CoreProductVariantSelect, 'productVariantSelect'],
                    ['carouselSwiper', CarouselSwiper],
                    ['footbedCarousel', FootbedCarousel, 'carouselSwiper'],
                    ['personalizationImagesCarousel', PersonalizationImagesCarousel, 'carouselSwiper'],
                    ['mobileProductVariantSelect', MobileProductVariantSelect, 'carouselSwiper'],
                    ['productVideo', CoreProductVideo, 'productVideo'],
                    ['productSet', CoreAddAllToCartMixin, 'productSet'],
                    ['productSet', CoreRecentlyViewedMixin, 'productSet'],
                    ['wannaARIFrame', WannaARIFrame],
                    ['wannaARIFrame', AccessibilityFocusTrapMixin, 'wannaARIFrame'],
                    ['wannaARButton', WannaARButton],
                    ['yotpoRecommendationSummary', YotpoRecommendationSummary],
                    ['fitPredictor', FitPredictor],
                    ['productStickyPanel', CoreProductStickyPanel],
                    ['vimeoVideo', VimeoVideo],
                    ['videoTeaser', VideoTeaser],
                    ['newsletterFlyIn', NewsletterFlyIn],
                    ['newsletterAutoFlyIn', NewsletterAutoFlyIn, 'newsletterFlyIn'],
                    ['productVariantSelect', ProductFocusManagementMixin, 'productVariantSelect'],
                    ['productDetail', AvailabilityReminderMixin, 'productDetail'],
                    ['drawerDialog', AvailabilityReminderModalMixin, 'drawerDialog'],
                    ['drawerDialog', SignInToBuyModalMixin, 'drawerDialog'],
                    ['drawerDialog', EnrollLoyaltyToBuyModalMixin, 'drawerDialog'],
                    ['productActionButton', ProductActionButton, 'button'],
                    ['storeAvailabilityBtn', StoreAvailabilityBtn, 'productActionButton'],
                    ['reviewsAccordionItem', ReviewsAccordionItem, 'accordionItem'],
                    ['pageLoadActionProcessor', PageLoadActionProcessor],
                    ['addToCartMixin', AddToCartMixin],
                    ['dynamicRecommendations', DynamicRecommendations],
                    ['productFeatures', ProductFeatures],
                    ['tamaraWidget', TamaraWidget]
                ]
            };
        })
});

WidgetsMgr.asyncLists.push({
    getLoadingFlag: () => hasContext('pdp') && hasContext('carousel'),
    load: () =>
        Promise.all([
            import(/* webpackChunkName: 'product.carousel' */ './product/CoreProductImages').then(d => d.default),
            import(/* webpackChunkName: 'product.carousel' */ './product/CoreProductVideoMixin').then(d => d.default),
            import(/* webpackChunkName: 'product.carousel' */ './product/CoreProductImagesCarousel').then(d => d.default)
        ]).then(deps => {
            const [CoreProductImages, CoreProductVideoMixin, CoreProductImagesCarousel] = deps;

            return {
                listId: 'product.carousel.widgets.core',
                widgetsDefinition: () => [
                    ['productImages', CoreProductImages, 'productImages'],
                    ['productImagesCarousel', CoreProductVideoMixin, 'productImagesCarousel'],
                    ['productImagesCarousel', CoreProductImagesCarousel, 'productImagesCarousel']
                ]
            };
        })
});

/* Used ProductImagesGallery for md.lg.xl views and ProductImagesCarousel for sm view */
WidgetsMgr.asyncLists.push({
    getLoadingFlag: () => hasContext('pdp') && hasContext('gallery'),
    load: () =>
        Promise.all([
            import(/* webpackChunkName: 'product.gallery' */ './product/CoreProductImages').then(d => d.default),
            import(/* webpackChunkName: 'product.gallery' */ './product/CoreProductImagesGallery').then(d => d.default)
        ]).then(deps => {
            const [CoreProductImages, CoreProductImagesGallery] = deps;

            return {
                listId: 'product.gallery.widgets.core',
                widgetsDefinition: () => [
                    ['productImages', CoreProductImages, 'productImages'],
                    ['productImagesGallery', CoreProductImagesGallery, 'productImages']
                ]
            };
        })
});

WidgetsMgr.asyncLists.push({
    getLoadingFlag: () => hasContext('plp'),
    load: () =>
        Promise.all([
            import(/* webpackChunkName: 'search.widgets' */ './search/CoreRefinementMenuItem').then(d => d.default),
            import(/* webpackChunkName: 'search.widgets' */ './search/CoreRefinement').then(d => d.default),
            import(/* webpackChunkName: 'search.widgets' */ './global/CoreSizeTabs').then(d => d.default),
            import(/* webpackChunkName: 'search.widgets' */ './search/CoreProductListingMgr').then(d => d.default),
            import(/* webpackChunkName: 'search.widgets' */ './search/RefinementsShowMore').then(d => d.default),
            import(/* webpackChunkName: 'search.widgets' */ './search/RefinementsPanel').then(d => d.default),
            import(/* webpackChunkName: 'search.widgets' */ './search/RefinementsPanelToggle').then(d => d.default),
            import(/* webpackChunkName: 'product.widgets' */ 'widgets/global/CarouselSwiper').then(d => d.default),
            import(/* webpackChunkName: 'search.widgets' */ './search/SwatchCarousel').then(d => d.default),
            import(/* webpackChunkName: 'search.widgets' */ './search/SwatchCarouselSwiper').then(d => d.default),
            import(/* webpackChunkName: 'search.widgets' */ './search/CoreStickyPanel').then(d => d.default),
            import(/* webpackChunkName: 'search.widgets' */ './search/CoreRefinementPriceRange').then(d => d.default),
            import(/* webpackChunkName: 'homepage.widgets' */ 'core/global/NewsletterFlyIn').then(d => d.default),
            import(/* webpackChunkName: 'search.widgets' */ 'core/global/NewsletterAutoFlyIn').then(d => d.default),
            import(/* webpackChunkName: 'cart.widgets' */ './global/OptimizelyMixin').then(d => d.default)
        ]).then(deps => {
            const [
                CoreRefinementMenuItem,
                CoreRefinement,
                SizeTabs,
                CoreProductListingMgr,
                RefinementsShowMore,
                RefinementsPanel,
                RefinementsPanelToggle,
                CarouselSwiper,
                SwatchCarousel,
                SwatchCarouselSwiper,
                CoreStickyPanel,
                CoreRefinementPriceRange,
                NewsletterFlyIn,
                NewsletterAutoFlyIn,
                OptimizelyMixin
            ] = deps;

            return {
                listId: 'search.widgets.core',
                widgetsDefinition: () => [
                    // listAccessibility
                    ['refinementMenuItem', CoreRefinementMenuItem, 'refinementMenuItem'],
                    // tabs
                    ['refinement', CoreRefinement, 'refinement'],
                    ['sizeTabs', SizeTabs, 'tabs'],
                    ['sizeTabs', OptimizelyMixin, 'sizeTabs'],
                    ['productListingMgr', CoreProductListingMgr, 'productListingMgr'],
                    ['productListingMgr', OptimizelyMixin, 'productListingMgr'],
                    ['productListingMgr', AccessibilityFocusTrapMixin, 'productListingMgr'],
                    ['refinementsShowMore', RefinementsShowMore],
                    ['refinementsPanel', RefinementsPanel, 'modal'],
                    ['refinementsPanelToggle', RefinementsPanelToggle],
                    ['carouselSwiper', CarouselSwiper],
                    ['swatchCarousel', SwatchCarousel],
                    ['swatchCarousel', OptimizelyMixin, 'swatchCarousel'],
                    ['swatchCarouselSwiper', SwatchCarouselSwiper, 'carouselSwiper'],
                    ['stickyPanel', CoreStickyPanel, 'stickyPanel'],
                    ['refinementPriceRange', CoreRefinementPriceRange, 'refinementPriceRange'],
                    ['newsletterFlyIn', NewsletterFlyIn],
                    ['newsletterAutoFlyIn', NewsletterAutoFlyIn, 'newsletterFlyIn'],
                    ['productTile', OptimizelyMixin, 'productTile']
                ]
            };
        })
});

WidgetsMgr.asyncLists.push({
    getLoadingFlag: () => hasContext('cart'),
    load: () =>
        Promise.all([
            import(/* webpackChunkName: 'cart.widgets' */ './cart/CoreCartMgr').then(d => d.default),
            import(/* webpackChunkName: 'cart.widgets' */ 'widgets/product/ProductOptionMixin').then(d => d.default),
            import(/* webpackChunkName: 'cart.widgets' */ './global/OptimizelyMixin').then(d => d.default),
            import(/* webpackChunkName: 'cart.widgets' */ './cart/CartCheckoutSignInToBuyMixin').then(d => d.default),
            import(/* webpackChunkName: 'cart.widgets' */ './product/SignInToBuyModalMixin').then(d => d.default),
            import(/* webpackChunkName: 'cart.widgets' */ './product/EnrollLoyaltyToBuyModalMixin').then(d => d.default),
            import(/* webpackChunkName: 'cart.widgets' */ './forms/ajax/SignInToBuyLoginForm').then(d => d.default),
            import(/* webpackChunkName: 'cart.widgets' */ './forms/ajax/EnrollLoyaltyToBuyLoginForm').then(d => d.default),
            import(/* webpackChunkName: 'wishlist.wishlist' */ 'core/account/SignInToBuyRegistrationForm').then(d => d.default),
            import(/* webpackChunkName: 'cart.widgets' */ 'widgets/product/ProductDetail').then(d => d.default),
            import(/* webpackChunkName: 'cart.widgets' */ './product/CoreProductDetail').then(d => d.default),
            import(/* webpackChunkName: 'cart.widgets' */ './cart/CartStickyPanel').then(d => d.default),
            import(/* webpackChunkName: 'cart.widgets' */ './cart/CoreCheckoutButtons').then(d => d.default),
            import(/* webpackChunkName: 'cart.widgets' */ './forms/CoreCouponForm').then(d => d.default),
            import(/* webpackChunkName: 'product.widgets' */ './product/ChangeStoreSelectorBtn').then(d => d.default),
            import(/* webpackChunkName: 'product.widgets' */ './product/ProductDeliveryOptions').then(d => d.default),
            import(/* webpackChunkName: 'cart.widgets' */ './cart/IdmeCard').then(d => d.default),
            import(/* webpackChunkName: 'cart.widgets' */ './cart/YotpoLoyaltyRewards').then(d => d.default),
            import(/* webpackChunkName: 'cart.widgets' */ './cart/OrderBonusChoice').then(d => d.default),
            import(/* webpackChunkName: 'product.widgets' */ './product/AvailabilityReminderMixin').then(d => d.default),
            import(/* webpackChunkName: 'product.widgets' */ './product/AvailabilityReminderModalMixin').then(d => d.default),
            import(/* webpackChunkName: 'giftcertificate.widgets' */ './forms/GiftCertificatePurchaseForm').then(d => d.default),
            import(/* webpackChunkName: 'cart.widgets' */ './product/ProductDetailCrossSellMixin').then(d => d.default),
            import(/* webpackChunkName: 'search.widgets' */ './search/SwatchCarousel').then(d => d.default),
            import(/* webpackChunkName: 'product.widgets' */ './product/PersonalizationSummary').then(d => d.default),
            import(/* webpackChunkName: 'product.widgets' */ './product/PersonalizationDrawer').then(d => d.default)
        ]).then(deps => {
            const [
                CoreCartMgr,
                ProductOptionMixin,
                OptimizelyMixin,
                CartCheckoutSignInToBuyMixin,
                SignInToBuyModalMixin,
                EnrollLoyaltyToBuyModalMixin,
                SignInToBuyLoginForm,
                EnrollLoyaltyToBuyLoginForm,
                SignInToBuyRegistrationForm,
                ProductDetail,
                CoreProductDetail,
                CartStickyPanel,
                CoreCheckoutButtons,
                CoreCouponForm,
                ChangeStoreSelectorBtn,
                ProductDeliveryOptions,
                IdmeCard,
                YotpoLoyaltyRewards,
                OrderBonusChoice,
                AvailabilityReminderMixin,
                AvailabilityReminderModalMixin,
                GiftCertificatePurchaseForm,
                ProductDetailCrossSellMixin,
                SwatchCarousel,
                PersonalizationSummary,
                PersonalizationDrawer
            ] = deps;

            return {
                listId: 'cart.widgets.core',
                widgetsDefinition: () => [
                    ['cartMgr', CoreCartMgr, 'cartMgr'],
                    ['cartMgr', AccessibilityFocusMixin, 'cartMgr'],
                    ['checkoutButtons', CoreCheckoutButtons, 'checkoutButtons'],
                    ['checkoutButtons', CartCheckoutSignInToBuyMixin, 'checkoutButtons'],
                    ['checkoutButtons', OptimizelyMixin, 'checkoutButtons'],
                    ['drawerDialog', SignInToBuyModalMixin, 'drawerDialog'],
                    ['drawerDialog', EnrollLoyaltyToBuyModalMixin, 'drawerDialog'],
                    ['signInToBuyLoginForm', SignInToBuyLoginForm, 'loginForm'],
                    ['enrollLoyaltyToBuyLoginForm', EnrollLoyaltyToBuyLoginForm, 'loginForm'],
                    ['signInToBuyRegistrationForm', SignInToBuyRegistrationForm, 'loginForm'],
                    ['ajaxform', SmsSubscriptionMixin, 'ajaxform'],
                    ['cartStickyPanel', CartStickyPanel],
                    ['cartStickyPanel', OptimizelyMixin, 'cartStickyPanel'],
                    ['productDetailCrossSell', ProductDetail],
                    ['productDetailCrossSell', CoreProductTile, 'productDetailCrossSell'],
                    ['productDetailCrossSell', ProductDetailCrossSellMixin, 'productDetailCrossSell'],
                    ['productDetailCrossSell', AddToCartMixin, 'productDetailCrossSell'],
                    ['productDetailCrossSell', ProductOptionMixin, 'productDetailCrossSell'],
                    ['productDetailCrossSell', CoreProductDetail, 'productDetailCrossSell'],
                    ['productDetailCrossSell', CoreAddToCartMixin, 'productDetailCrossSell'],
                    ['changeStoreSelectorBtn', ChangeStoreSelectorBtn],
                    ['productDeliveryOptions', ProductDeliveryOptions],
                    ['couponform', CoreCouponForm, 'couponform'],
                    ['idmeCard', IdmeCard],
                    ['yotpoLoyaltyRewards', YotpoLoyaltyRewards, 'disclosure'],
                    ['orderBonusChoice', OrderBonusChoice],
                    ['productDetail', AvailabilityReminderMixin, 'productDetail'],
                    ['drawerDialog', AvailabilityReminderModalMixin, 'drawerDialog'],
                    ['giftCertificatePurchaseForm', GiftCertificatePurchaseForm, 'ajaxform'],
                    ['swatchCarousel', SwatchCarousel],
                    ['personalizationSummary', PersonalizationSummary],
                    ['personalizationDrawer', PersonalizationDrawer, 'modal']
                ]
            };
        })
});

WidgetsMgr.asyncLists.push({
    getLoadingFlag: () => hasContext('giftcertificate'),
    load: () =>
        Promise.all([
            import(/* webpackChunkName: 'giftcertificate.widgets' */ './giftCertificate/GiftCertificateCheckBalance').then(d => d.default),
            import(/* webpackChunkName: 'giftcertificate.widgets' */ './forms/GiftCertificateCheckBalanceForm').then(d => d.default),
            import(/* webpackChunkName: 'giftcertificate.widgets' */ './forms/GiftCertificatePurchaseForm').then(d => d.default),
            import(/* webpackChunkName: 'giftcertificate.widgets' */ './forms/FaqToggle').then(d => d.default)
        ]).then(deps => {
            const [GiftCertificateCheckBalance, GiftCertificateCheckBalanceForm, GiftCertificatePurchaseForm, FaqToggle] = deps;

            return {
                listId: 'giftcertificate.widgets.core',
                widgetsDefinition: () => [
                    ['giftCertificateCheckBalance', GiftCertificateCheckBalance],
                    ['giftCertificateCheckBalance', AccessibilityFocusMixin, 'giftCertificateCheckBalance'],
                    ['giftCertificateCheckBalanceForm', GiftCertificateCheckBalanceForm, 'ajaxform'],
                    ['giftCertificatePurchaseForm', GiftCertificatePurchaseForm, 'ajaxform'],
                    ['faqToggle', FaqToggle]
                ]
            };
        })
});

WidgetsMgr.asyncLists.push({
    getLoadingFlag: () => hasContext('checkout'),
    load: () =>
        Promise.all([
            import(/* webpackChunkName: 'checkout.widgets' */ './checkout/CoreBillingForm').then(d => d.default),
            import(/* webpackChunkName: 'checkout.widgets' */ './checkout/PaymentBillingForm').then(d => d.default),
            import(/* webpackChunkName: 'checkout.widgets' */ './checkout/CheckoutcomComponent').then(d => d.default),
            import(/* webpackChunkName: 'checkout.widgets' */ './checkout/CheckoutcomWalletComponent').then(d => d.default),
            import(/* webpackChunkName: 'checkout.widgets' */ './forms/DimensionalDropdown').then(d => d.default),
            import(/* webpackChunkName: 'checkout.widgets' */ './checkout/CoreShippingForm').then(d => d.default),
            import(/* webpackChunkName: 'checkout.widgets' */ './forms/CoreAddressForm').then(d => d.default),
            import(/* webpackChunkName: 'checkout.widgets' */ './global/ShowHiddenField').then(d => d.default),
            import(/* webpackChunkName: 'checkout.widgets' */ './forms/GoogleAutocompleteFieldExt').then(d => d.default),
            import(/* webpackChunkName: 'checkout.widgets' */ './checkout/CoreCheckoutMgr').then(d => d.default),
            import(/* webpackChunkName: 'checkout.widgets' */ './cart/CartCheckoutSignInToBuyMixin').then(d => d.default),
            import(/* webpackChunkName: 'checkout.widgets' */ './product/SignInToBuyModalMixin').then(d => d.default),
            import(/* webpackChunkName: 'checkout.widgets' */ './product/EnrollLoyaltyToBuyModalMixin').then(d => d.default),
            import(/* webpackChunkName: 'checkout.widgets' */ './forms/ajax/SignInToBuyLoginForm').then(d => d.default),
            import(/* webpackChunkName: 'checkout.widgets' */ './forms/ajax/EnrollLoyaltyToBuyLoginForm').then(d => d.default),
            import(/* webpackChunkName: 'checkout.widgets' */ 'core/account/SignInToBuyRegistrationForm').then(d => d.default),
            import(/* webpackChunkName: 'cart.widgets' */ './global/OptimizelyMixin').then(d => d.default),
            import(/* webpackChunkName: 'checkout.widgets' */ './global/CoreAccessibilityFocusMixin').then(d => d.default),
            import(/* webpackChunkName: 'checkout.widgets' */ './checkout/CoreSummaryStepMixin').then(d => d.default),
            import(/* webpackChunkName: 'checkout.widgets' */ './checkout/CheckoutcomSummaryMixin').then(d => d.default),
            import(/* webpackChunkName: 'checkout.widgets' */ './checkout/CoreCheckoutStepMixin').then(d => d.default),
            import(/* webpackChunkName: 'checkout.widgets' */ './checkout/CoreShippingStepMixin').then(d => d.default),
            import(/* webpackChunkName: 'checkout.widgets' */ './checkout/CoreBillingStepMixin').then(d => d.default),
            import(/* webpackChunkName: 'checkout.widgets' */ './checkout/CoreShippingMethodForm').then(d => d.default),
            import(/* webpackChunkName: 'checkout.widgets' */ './checkout/CoreSummaryForm').then(d => d.default),
            import(/* webpackChunkName: 'checkout.widgets' */ 'widgets/forms/CouponForm').then(d => d.default),
            import(/* webpackChunkName: 'checkout.widgets' */ './forms/CoreCouponForm').then(d => d.default),
            import(/* webpackChunkName: 'checkout.widgets' */ './forms/GiftCertificateForm').then(d => d.default),
            import(/* webpackChunkName: 'checkout.widgets' */ './checkout/CorePaymentAccordion').then(d => d.default),
            import(/* webpackChunkName: 'checkout.widgets' */ './checkout/CorePaymentAccordionItem').then(d => d.default),
            import(/* webpackChunkName: 'checkout.widgets' */ './checkout/CoreAddressCheckoutForm').then(d => d.default),
            import(/* webpackChunkName: 'checkout.widgets' */ './checkout/CoreRadioSelector').then(d => d.default),
            import(/* webpackChunkName: 'account.widgets' */ './checkout/PickupContactForm').then(d => d.default),
            import(/* webpackChunkName: 'account.widgets' */ './checkout/PickupPointForm').then(d => d.default),
            import(/* webpackChunkName: 'account.widgets' */ './checkout/PickupPointSearchMixin').then(d => d.default),
            import(/* webpackChunkName: 'checkout.arvatopudo' */ './checkout/ArvatoPudoMixin').then(d => d.default),
            import(/* webpackChunkName: 'checkout.avs' */ './checkout/AvsCheckoutMgr').then(d => d.default),
            import(/* webpackChunkName: 'checkout.avs' */ './forms/AddressVerificationMixin').then(d => d.default),
            import(/* webpackChunkName: 'checkout.avs' */ './checkout/AvsAddressCheckoutForm').then(d => d.default),
            import(/* webpackChunkName: 'checkout.avs' */ './forms/MatchedAddressesModal').then(d => d.default),
            import(/* webpackChunkName: 'return.widgets' */ './return/ReturnPickupCalendar').then(d => d.default),
            import(/* webpackChunkName: 'checkout.widgets' */ './forms/AddressSearch').then(d => d.default),
            import(/* webpackChunkName: 'checkout.widgets' */ './cart/YotpoLoyaltyRewards').then(d => d.default)
        ]).then(deps => {
            const [
                CoreBillingForm,
                PaymentBillingForm,
                CheckoutcomComponent,
                CheckoutcomWalletComponent,
                DimensionalDropdown,
                CoreShippingForm,
                CoreAddressForm,
                ShowHiddenField,
                GoogleAutocompleteFieldExt,
                CoreCheckoutMgr,
                CartCheckoutSignInToBuyMixin,
                SignInToBuyModalMixin,
                EnrollLoyaltyToBuyModalMixin,
                SignInToBuyLoginForm,
                EnrollLoyaltyToBuyLoginForm,
                SignInToBuyRegistrationForm,
                OptimizelyMixin,
                CoreAccessibilityFocusMixin,
                CoreSummaryStepMixin,
                CheckoutcomSummaryMixin,
                CoreCheckoutStepMixin,
                CoreShippingStepMixin,
                CoreBillingStepMixin,
                CoreShippingMethodForm,
                CoreSummaryForm,
                CouponForm,
                CoreCouponForm,
                GiftCertificateForm,
                CorePaymentAccordion,
                CorePaymentAccordionItem,
                CoreAddressCheckoutForm,
                CoreRadioSelector,
                PickupContactForm,
                PickupPointForm,
                PickupPointSearchMixin,
                ArvatoPudoMixin,
                AvsCheckoutMgr,
                AddressVerificationMixin,
                AvsAddressCheckoutForm,
                MatchedAddressesModal,
                ReturnPickupCalendar,
                AddressSearch,
                YotpoLoyaltyRewards
            ] = deps;

            return {
                listId: 'checkout.form.core',
                widgetsDefinition: () => [
                    ['billingForm', CoreBillingForm, 'billingForm'],
                    ['paymentBillingForm', PaymentBillingForm, 'addressCheckoutForm'],
                    ['checkoutcomComponent', CheckoutcomComponent, 'paymentAccordionItem'],
                    ['checkoutcomWalletComponent', CheckoutcomWalletComponent, 'checkoutcomComponent'],
                    ['dimensionalDropdown', DimensionalDropdown, 'inputSelect'],
                    ['shippingForm', CoreShippingForm, 'shippingForm'],
                    ['addressForm', CoreAddressForm, 'addressForm'],
                    ['addressCheckoutForm', CoreAddressCheckoutForm, 'addressCheckoutForm'],
                    ['googleAutocompleteField', GoogleAutocompleteFieldExt, 'googleAutocompleteField'],
                    ['checkoutMgr', CoreCheckoutMgr, 'checkoutMgr'],
                    ['checkoutMgr', CoreAccessibilityFocusMixin, 'checkoutMgr'],
                    ['checkoutMgr', CartCheckoutSignInToBuyMixin, 'checkoutMgr'],
                    ['checkoutMgr', OptimizelyMixin, 'checkoutMgr'],
                    ['drawerDialog', SignInToBuyModalMixin, 'drawerDialog'],
                    ['drawerDialog', EnrollLoyaltyToBuyModalMixin, 'drawerDialog'],
                    ['signInToBuyLoginForm', SignInToBuyLoginForm, 'loginForm'],
                    ['enrollLoyaltyToBuyLoginForm', EnrollLoyaltyToBuyLoginForm, 'loginForm'],
                    ['signInToBuyRegistrationForm', SignInToBuyRegistrationForm, 'registrationForm'],
                    ['checkoutMgr', CoreSummaryStepMixin, 'checkoutMgr'],
                    ['checkoutMgr', CheckoutcomSummaryMixin, 'checkoutMgr'],
                    ['checkoutMgr', CoreCheckoutStepMixin, 'checkoutMgr'],
                    ['checkoutMgr', CoreShippingStepMixin, 'checkoutMgr'],
                    ['checkoutMgr', CoreBillingStepMixin, 'checkoutMgr'],
                    ['shippingMethodForm', CoreShippingMethodForm, 'addressCheckoutForm'],
                    ['summaryForm', CoreSummaryForm, 'ajaxform'],
                    ['couponform', CouponForm, 'ajaxform'],
                    ['couponform', CoreCouponForm, 'couponform'],
                    ['giftcertificateform', GiftCertificateForm, 'ajaxform'],
                    ['paymentAccordion', CorePaymentAccordion, 'paymentAccordion'],
                    ['paymentAccordionItem', CorePaymentAccordionItem, 'paymentAccordionItem'],
                    ['radioSelector', CoreRadioSelector, 'radioSelector'],
                    ['pickupContactForm', PickupContactForm, 'ajaxform'],
                    ['pickupPointForm', PickupPointForm, 'addressForm'],
                    ['pickupPointSearchForm', PickupPointSearchMixin, 'pickupPointForm'],
                    ['arvatoPudoPickupPointForm', ArvatoPudoMixin, 'pickupPointForm'],
                    ['checkoutMgr', AvsCheckoutMgr, 'checkoutMgr'],
                    ['addressCheckoutForm', AddressVerificationMixin, 'addressCheckoutForm'],
                    ['addressCheckoutForm', ShowHiddenField, 'addressCheckoutForm'],
                    ['shippingForm', AvsAddressCheckoutForm, 'shippingForm'],
                    ['matchedAddressesModal', MatchedAddressesModal],
                    ['returnPickupCalendar', ReturnPickupCalendar],
                    ['AddressSearch', AddressSearch],
                    ['yotpoLoyaltyRewards', YotpoLoyaltyRewards, 'disclosure']
                ]
            };
        })
});

WidgetsMgr.asyncLists.push({
    getLoadingFlag: () => hasContext('account'),
    load: () =>
        Promise.all([
            import(/* webpackChunkName: 'account.widgets' */ './account/AddressBook').then(d => d.default),
            import(/* webpackChunkName: 'account.widgets' */ './account/CoreAddressList').then(d => d.default),
            import(/* webpackChunkName: 'account.widgets' */ './forms/DimensionalDropdown').then(d => d.default),
            import(/* webpackChunkName: 'account.widgets' */ './forms/CoreAddressForm').then(d => d.default),
            import(/* webpackChunkName: 'account.widgets' */ './forms/GoogleAutocompleteFieldExt').then(d => d.default),
            import(/* webpackChunkName: 'account.widgets' */ './account/AccountAddressForm').then(d => d.default),
            import(/* webpackChunkName: 'account.widgets' */ './global/ShowHiddenField').then(d => d.default),
            import(/* webpackChunkName: 'account.widgets' */ './account/CorePasswordResetForm').then(d => d.default),
            import(/* webpackChunkName: 'account.widgets' */ './account/RegistrationForm').then(d => d.default),
            import(/* webpackChunkName: 'account.widgets' */ 'widgets/global/CarouselSwiper').then(d => d.default),
            import(/* webpackChunkName: 'account.widgets' */ './account/Loyalty').then(d => d.default),
            import(/* webpackChunkName: 'account.widgets' */ './account/QRCodeWidget').then(d => d.default),
            import(/* webpackChunkName: 'account.widgets' */ './account/LoyaltyCouponsLoader').then(d => d.default),
            import(/* webpackChunkName: 'account.widgets' */ './account/CopyCoupon').then(d => d.default),
            import(/* webpackChunkName: 'account.widgets' */ './forms/AddressSearch').then(d => d.default),
            import(/* webpackChunkName: 'account.widgets' */ './account/YotpoLoyaltyOptForm').then(d => d.default)
        ]).then(deps => {
            const [
                AddressBook,
                CoreAddressList,
                DimensionalDropdown,
                CoreAddressForm,
                GoogleAutocompleteFieldExt,
                AccountAddressForm,
                ShowHiddenField,
                CorePasswordResetForm,
                RegistrationForm,
                CarouselSwiper,
                Loyalty,
                QRCodeWidget,
                LoyaltyCouponsLoader,
                CopyCoupon,
                AddressSearch,
                YotpoLoyaltyOptForm
            ] = deps;

            return {
                listId: 'account.form.core',
                widgetsDefinition: () => [
                    ['addressBook', AddressBook],
                    ['addressList', CoreAddressList, 'addressList'],
                    ['dimensionalDropdown', DimensionalDropdown, 'inputSelect'],
                    ['addressForm', CoreAddressForm, 'addressForm'],
                    ['googleAutocompleteField', GoogleAutocompleteFieldExt, 'googleAutocompleteField'],
                    ['addressForm', AccountAddressForm, 'addressForm'],
                    ['addressForm', ShowHiddenField, 'addressForm'],
                    ['passwordResetForm', CorePasswordResetForm, 'passwordResetForm'],
                    ['ajaxform', SmsSubscriptionMixin, 'ajaxform'],
                    ['registrationForm', RegistrationForm, 'ajaxform'],
                    ['carouselSwiper', CarouselSwiper],
                    ['loyalty', Loyalty],
                    ['QRCodeWidget', QRCodeWidget],
                    ['LoyaltyCouponsLoader', LoyaltyCouponsLoader],
                    ['copyCoupon', CopyCoupon],
                    ['AddressSearch', AddressSearch],
                    ['YotpoLoyaltyOptForm', YotpoLoyaltyOptForm, 'ajaxform']
                ]
            };
        })
});

WidgetsMgr.asyncLists.push({
    getLoadingFlag: () => hasContext('orderconfirmation'),
    load: () =>
        Promise.all([import(/* webpackChunkName: 'orderconfirmation.widgets' */ './account/RegistrationForm').then(d => d.default)]).then(deps => {
            const [RegistrationForm] = deps;

            return {
                listId: 'orderconfirmation.core',
                widgetsDefinition: () => [['registrationForm', RegistrationForm, 'ajaxform']]
            };
        })
});

WidgetsMgr.asyncLists.push({
    getLoadingFlag: () => hasContext('subscription'),
    load: () =>
        Promise.all([
            import(/* webpackChunkName: 'account.subscriptions' */ 'core/account/SubscriptionPreferencesMgr').then(d => d.default),
            import(/* webpackChunkName: 'account.subscriptions' */ 'core/account/CoreSubscriptionsForm').then(d => d.default),
            import(/* webpackChunkName: 'account.subscriptions' */ './forms/InputCheckboxGroupMixin').then(d => d.default)
        ]).then(deps => {
            const [SubscriptionPreferencesMgr, CoreSubscriptionsForm, InputCheckboxGroupMixin] = deps;

            return {
                listId: 'account.subscriptions.core',
                widgetsDefinition: () => [
                    ['subscriptionPreferencesMgr', SubscriptionPreferencesMgr],
                    ['subscriptionsForm', CoreSubscriptionsForm, 'subscriptionsForm'],
                    ['inputCheckboxGroup', InputCheckboxGroupMixin, 'inputCheckboxGroup']
                ]
            };
        })
});

WidgetsMgr.asyncLists.push({
    getLoadingFlag: () => hasContext('home'),
    load: () =>
        Promise.all([
            import(/* webpackChunkName: 'homepage.widgets' */ 'core/global/NewsletterFlyIn').then(d => d.default),
            import(/* webpackChunkName: 'homepage.widgets' */ 'core/global/NewsletterAutoFlyIn').then(d => d.default),
            import(/* webpackChunkName: 'homepage.widgets' */ 'core/global/CombinedProductCarousel').then(d => d.default),
            import(/* webpackChunkName: 'homepage.widgets' */ './global/OptimizelyMixin').then(d => d.default)
        ]).then(deps => {
            const [NewsletterFlyIn, NewsletterAutoFlyIn, CombinedProductCarousel, OptimizelyMixin] = deps;

            return {
                listId: 'homepage.widgets.core',
                widgetsDefinition: () => [
                    ['newsletterFlyIn', NewsletterFlyIn],
                    ['newsletterAutoFlyIn', NewsletterAutoFlyIn, 'newsletterFlyIn'],
                    ['combinedProductCarousel', CombinedProductCarousel, 'tabs'],
                    ['combinedProductCarousel', OptimizelyMixin, 'combinedProductCarousel']
                ]
            };
        })
});

WidgetsMgr.asyncLists.push({
    getLoadingFlag: () => hasContext('content'),
    load: () =>
        Promise.all([
            import(/* webpackChunkName: 'content.widgets' */ 'widgets/account/SubscriptionsForm').then(d => d.default),
            import(/* webpackChunkName: 'content.widgets' */ 'core/account/CoreSubscriptionsForm').then(d => d.default),
            import(/* webpackChunkName: 'content.widgets' */ 'core/forms/TrackOrder').then(d => d.default),
            import(/* webpackChunkName: 'content.widgets' */ 'core/content/FaqSearchBox').then(d => d.default),
            import(/* webpackChunkName: 'content.widgets' */ 'core/content/FaqSearchResults').then(d => d.default)
        ]).then(deps => {
            const [SubscriptionsForm, CoreSubscriptionsForm, TrackOrder, FaqSearchBox, FaqSearchResults] = deps;

            return {
                listId: 'content.widgets.core',
                widgetsDefinition: () => [
                    ['subscriptionsForm', SubscriptionsForm, 'ajaxform'],
                    ['subscriptionsForm', CoreSubscriptionsForm, 'subscriptionsForm'],
                    ['trackOrder', TrackOrder, 'ajaxform'],
                    ['faqSearchBox', FaqSearchBox],
                    ['faqSearchResults', FaqSearchResults]
                ]
            };
        })
});

WidgetsMgr.asyncLists.push({
    getLoadingFlag: () => hasContext('clp'),
    load: () =>
        Promise.all([
            import(/* webpackChunkName: 'clp.widgets' */ 'widgets/content/ContactUs').then(d => d.default),
            import(/* webpackChunkName: 'clp.widgets' */ 'widgets/global/CarouselSwiper').then(d => d.default),
            import(/* webpackChunkName: 'clp.widgets' */ 'core/global/ContentGalleryCarousel').then(d => d.default),
            import(/* webpackChunkName: 'clp.widgets' */ 'core/global/VideoTeaser').then(d => d.default),
            import(/* webpackChunkName: 'homepage.widgets' */ 'core/global/NewsletterFlyIn').then(d => d.default),
            import(/* webpackChunkName: 'clp.widgets' */ 'core/global/NewsletterAutoFlyIn').then(d => d.default)
        ]).then(deps => {
            const [ContactUs, CarouselSwiper, ContentGalleryCarousel, VideoTeaser, NewsletterFlyIn, NewsletterAutoFlyIn] = deps;

            return {
                listId: 'content.widgets.core',
                widgetsDefinition: () => [
                    ['contactUs', ContactUs],
                    ['carouselSwiper', CarouselSwiper],
                    ['contentGalleryCarousel', ContentGalleryCarousel, 'carouselSwiper'],
                    ['videoTeaser', VideoTeaser],
                    ['newsletterFlyIn', NewsletterFlyIn],
                    ['newsletterAutoFlyIn', NewsletterAutoFlyIn, 'newsletterFlyIn']
                ]
            };
        })
});

WidgetsMgr.asyncLists.push({
    getLoadingFlag: () => hasContext('sustainability'),
    load: () =>
        Promise.all([
            import(/* webpackChunkName: 'sustainability.widgets' */ './sustainability/ProductListSustainability').then(d => d.default)
        ]).then(deps => {
            const [ProductListSustainability] = deps;

            return {
                listId: 'sustainability.widgets.core',
                widgetsDefinition: () => [['productListSustainability', ProductListSustainability]]
            };
        })
});

/**
 * Sign in modal for the member price badge (product tiles, minicart) on pages
 * where it is not registered by the page specific widgets lists (pdp, cart, checkout, wishlist)
 */
WidgetsMgr.asyncLists.push({
    getLoadingFlag: () => !['pdp', 'cart', 'checkout', 'wishlist'].some(context => hasContext(context)),
    load: () =>
        Promise.all([
            import(/* webpackChunkName: 'memberprice.widgets' */ './product/SignInToBuyModalMixin').then(d => d.default),
            import(/* webpackChunkName: 'memberprice.widgets' */ './forms/ajax/SignInToBuyLoginForm').then(d => d.default),
            import(/* webpackChunkName: 'memberprice.widgets' */ './account/RegistrationForm').then(d => d.default),
            import(/* webpackChunkName: 'memberprice.widgets' */ './account/SignInToBuyRegistrationForm').then(d => d.default)
        ]).then(deps => {
            const [SignInToBuyModalMixin, SignInToBuyLoginForm, RegistrationForm, SignInToBuyRegistrationForm] = deps;

            return {
                listId: 'memberprice.widgets.core',
                widgetsDefinition: () => [
                    ['drawerDialog', SignInToBuyModalMixin, 'drawerDialog'],
                    ['signInToBuyLoginForm', SignInToBuyLoginForm, 'loginForm'],
                    // registered under own name, so that it does not conflict with `registrationForm` of account pages
                    ['signInToBuyRegistrationForm', RegistrationForm, 'ajaxform'],
                    ['signInToBuyRegistrationForm', SignInToBuyRegistrationForm, 'signInToBuyRegistrationForm']
                ]
            };
        })
});
